if (!customElements.get('variant-selects')) {

  customElements.define(
    'variant-selects',
    class VariantSelects extends HTMLElement {
      constructor() {
        super();
      }
      get selectedOptionValues() {
        return Array.from(this.querySelectorAll('select option[selected], fieldset input:checked')).map(
          ({ dataset }) => dataset.optionValueId
        );
      }
      getInputForEventTarget(target) {
        return target.tagName === 'SELECT' ? target.selectedOptions[0] : target;
      }

      connectedCallback() {
        this.addEventListener('change', (event) => {
          const target = this.getInputForEventTarget(event.target);
          this.updateSelectedSwatchValue(event);
          FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange, {
            data: {
              event,
              target,
              selectedOptionValues: this.selectedOptionValues,
            },
          });
        });
      }

      hideValueIfNoVariantChecked() {
        // Check all product form inputs
        this.querySelectorAll('.product-form__input').forEach(formInput => {
          // Check if any radio input is checked
          const hasCheckedRadio = formInput.querySelector('input[type="radio"]:checked');
          // Check if any select has a selected option
          const select = formInput.querySelector('select');
          const hasSelectedOption = select && select.querySelector('option[selected]');

          // If no variant is checked, clear the display value
          if (!hasCheckedRadio && !hasSelectedOption) {
            const selectedSwatchValue = formInput.querySelector('[data-selected-swatch-value], [data-selected-value]');
            if (selectedSwatchValue) {
              selectedSwatchValue.innerHTML = '';
            }
          }
        });
      }

      updateSelectedSwatchValue({ target }) {
        const { value, tagName } = target;
        if (tagName === 'SELECT' && target.selectedOptions.length) {
          Array.from(target.options)
            .find((option) => option.getAttribute('selected'))
            .removeAttribute('selected');
          target.selectedOptions[0].setAttribute('selected', 'selected');
          const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
          const selectedDropdownSwatchValue = target
            .closest('.product-form__input')
            .querySelector('[data-selected-value] > .swatch');
          if (!selectedDropdownSwatchValue) return;
          if (swatchValue) {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
            selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
          } else {
            selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
            selectedDropdownSwatchValue.classList.add('swatch--unavailable');
          }
          selectedDropdownSwatchValue.style.setProperty(
            '--swatch-focal-point',
            target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
          );
        } else if (tagName === 'INPUT' && target.type === 'radio') {
          // Update checked attribute for selected variant
          const formInput = target.closest('.product-form__input');
          const radioName = target.name;
          const allRadios = Array.from(formInput.querySelectorAll('input[type="radio"]')).filter(radio => radio.name === radioName);
          allRadios.forEach(radio => {
            if (radio === target) {
              radio.setAttribute('checked', 'checked');
            } else {
              radio.removeAttribute('checked');
            }
          });

          const selectedSwatchValue = formInput.querySelector('[data-selected-value]');
          if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
        }
      }
    }
  );
}
